import { Typography, Box, Grid, Button } from '@mui/material';
import React from 'react';
import { injectIntl } from 'react-intl';
import AdviserInfoTagChip from '../../../AdviserInfoPage/AdviserInfoTagChip/AdviserInfoTagChip';
import { SENIORITY_CHOICES, AGE_GROUP_CHOICES } from '../../../../constants/my-details';
import CompanyWithAutoComplete from './Component/CompanyWithAutoComplete';
import { useEffect } from 'react';

// Company, Age Group, Gender, Experience in Insurance, Name, Phone Number

function QuickProfileInput(props) {
  const { userDetails, intl, onNext, updateUserDetails } = props;

  const [company, setCompany] = React.useState(userDetails?.company);
  const [gender, setGender] = React.useState(userDetails?.gender);
  const [ageGroup, setAgeGroup] = React.useState(userDetails?.ageGroup);
  const [seniority, setSeniority] = React.useState(userDetails?.seniority);
  const [selectedColor, displayColor] = ['#3966f8', '#999999'];

  const handleUpdate = async () => {
    if (userDetails?._id && updateUserDetails) {
      const data = {
        _id: userDetails._id,
        company: company,
        gender: gender,
        ageGroup: ageGroup,
        seniority: seniority
      };
      updateUserDetails(data);
    }
    onNext();
  };

  useEffect(() => {
    if (!userDetails?._id) {
      handleSkip();
    }
  }, []);

  const handleSkip = () => {
    onNext();
  };

  return (
    <>
      <Box
        style={{
          padding: '20px 16px 30px 16px',
          maxWidth: '450px',
          margin: 'auto'
        }}
      >
        <form>
          <Typography variant="h4" style={{ marginBottom: '20px' }}>
            {intl.formatMessage({ id: 'easy-update-profile-heading' })}
          </Typography>
          <Typography variant="h5" style={{ marginBottom: '20px' }}>
            {intl.formatMessage({ id: 'easy-update-profile-subheading' })}
          </Typography>
          {/*  Company */}
          <CompanyWithAutoComplete
            className="input"
            variant="outlined"
            label={intl.formatMessage({ id: 'easy-update-profile-company' })}
            inputProps={{
              label: intl.formatMessage({ id: 'easy-update-profile-company' }),
              className: 'input',
              variant: 'outlined',
              name: 'company'
            }}
            optionProps={{
              style: {
                fontSize: '1.5rem'
              }
            }}
            onChange={value => setCompany(value)}
            value={company}
          />
          {<Typography style={{ color: 'grey', fontSize: 13 }}></Typography>}

          {/* Gender */}
          <Box style={{ padding: '24px 0px' }}>
            <Box style={{ marginBottom: '10px' }}>
              <Typography className="emoji" sx={{
                display: "inline"
              }}>
                {intl.formatMessage({ id: 'Gender' })}
              </Typography>
            </Box>
            <Grid container spacing={1} sx={{
              display: 'flex'
            }}>
              {['Male', 'Female'].map((tag, index) => (
                <Grid key={index} onClick={() => setGender(tag)}>
                  <AdviserInfoTagChip
                    color={displayColor}
                    filled={gender === tag ? selectedColor : undefined}
                    label={intl.formatMessage({ id: tag })}
                    isIntoView={true}
                  />
                </Grid>
              ))}
            </Grid>
          </Box>

          {/* Age Group */}
          <Box style={{ padding: '24px 0px' }}>
            <Box style={{ marginBottom: '10px' }}>
              <Typography className="emoji" sx={{
                display: "inline"
              }}>
                {intl.formatMessage({ id: 'easy-update-profile-age-group' })}
              </Typography>
            </Box>
            <Grid container spacing={1} sx={{
              display: 'flex'
            }}>
              {AGE_GROUP_CHOICES.map((tag, index) => (
                <Grid key={index} onClick={() => setAgeGroup(tag)}>
                  <AdviserInfoTagChip
                    color={displayColor}
                    filled={ageGroup === tag ? selectedColor : undefined}
                    label={tag}
                    isIntoView={true}
                  />
                </Grid>
              ))}
            </Grid>
          </Box>

          {/* Experience in Insurance */}
          <Box style={{ padding: '24px 0px' }}>
            <Box style={{ marginBottom: '10px' }}>
              <Typography className="emoji" sx={{
                display: "inline"
              }}>
                {intl.formatMessage({ id: 'seniority' })}
              </Typography>
            </Box>
            <Grid container spacing={1} sx={{
              display: 'flex'
            }}>
              {SENIORITY_CHOICES.map((tag, index) => (
                <Grid key={index} onClick={() => setSeniority(tag)}>
                  <AdviserInfoTagChip
                    color={displayColor}
                    label={intl.formatMessage({ id: `sen-${tag}` })}
                    isIntoView={true}
                    filled={seniority === tag ? selectedColor : undefined}
                  />
                </Grid>
              ))}
            </Grid>
          </Box>
          <Box style={{ padding: '18px 0px' }}></Box>
        </form>
        <Button variant="contained" color="primary" onClick={handleUpdate} fullWidth>
          {intl.formatMessage({ id: 'easy-update-profile-cta-update' })}
        </Button>
        <Box style={{ padding: '10px 0px' }}></Box>
        <Button variant="text" style={{ color: '#cccccc' }} onClick={handleSkip} fullWidth>
          {intl.formatMessage({ id: 'easy-update-profile-cta-skip' })}
        </Button>
      </Box>
    </>
  );
}

export default injectIntl(QuickProfileInput);
